<template>
  <div>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <va-card style="min-height: 500px">
      <h4>ANALYTICS DATA</h4>
      <div class="py-4">
        <b-row>
          <b-col cols="3">
            <h5 class="my-3">Search Selection</h5>

            <ul>
              <li v-for="(item, i) in buttons" :key="i" class="pt-1">
                <div>
                  <b-button
                    style="width: 100% !important"
                    class="py-2 px-4"
                    variant="success"
                    @click="newfunc(item.value)"
                    >{{ item.title }}</b-button
                  >
                </div>
              </li>
              <li v-if="level == 'online'" class="pt-1">
                <b-button
                  style="width: 100% !important"
                  class="py-2 px-4"
                  variant="success"
                  @click="newfunc('source')"
                  >Source</b-button
                >
              </li>
            </ul>
          </b-col>
          <b-col cols="5">
            <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'year'"
            >
              <h5 class="pt-4">Please Select Year Range</h5>
              <b-row>
                <b-col>
                  <p>From (Year) :</p>
                  <b-form-select
                    v-model="fromYear"
                    :options="years()"
                  ></b-form-select>
                </b-col>
                <b-col>
                  <p>To (Year) :</p>
                  <b-form-select
                    v-model="toYear"
                    :options="years()"
                  ></b-form-select>
                </b-col>
              </b-row>
              <!-- <b-col cols="12" class="card py-5" style="height: 180px">
                <b-row lass="text-center">
                  <b-col cols="4">
                    <span>From Date</span>
                  </b-col>
                  <b-col cols="8">
                    <b-form-datepicker
                      id="example-datepicker"
                      v-model="fromYear"
                      class="mb-2"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
                <b-row lass="text-center pt-3">
                  <b-col cols="4">
                    <span>To Date</span>
                  </b-col>
                  <b-col cols="8">
                    <b-form-datepicker
                      id="example-datepicker"
                      v-model="toYear"
                      class="mb-2"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
              </b-col> -->
            </b-row>
                <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'datewise'"
            >
              <h5 class="pt-4">Please Select Date Range</h5>
              <b-row>
                <b-col cols="12">
                  <p>From Date:</p>
                  <b-form-datepicker
                    v-model="fromDate"
                  ></b-form-datepicker>
                </b-col>
                <b-col cols="12">
                  <p>To Date :</p>
                   <b-form-datepicker
                    v-model="toDate"
                 ></b-form-datepicker>
                </b-col>
              </b-row>
            </b-row>
            <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'user'"
            >
              <h5 class="pt-3">Please Select an User Type</h5>
              <b-form-select
                v-model="user"
                :options="users"
                text-field="name"
                value-field="value"
              ></b-form-select>
            </b-row>
            <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'crime'"
            >
              <h5 class="pt-4">Please Select a Crime Type</h5>
              <b-form-select
                v-model="crime"
                :options="crimes"
                value-field="_id"
                text-field="cname"
              ></b-form-select>
            </b-row>
            <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'species'"
            >
              <h5 class="pt-4">Please Select a Species</h5>
              <b-form-select
                v-model="species"
                :options="allSpecies"
                value-field="_id"
                text-field="commonName"
              ></b-form-select>
            </b-row>
            <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'level'"
            >
              <h5 class="pt-4">Please Select a Level of Reporting</h5>
              <b-form-select v-model="level">
                <option value="online">Online Reporting</option>
                <option value="groundlevel">Field Reporting</option>
              </b-form-select>
            </b-row>
            <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'source'"
            >
              <h5 class="pt-4">Please Select a Source Type</h5>
              <b-form-select
                v-model="source"
                :options="sources"
                value-field="_id"
                text-field="sname"
              ></b-form-select>
            </b-row>
            <b-row
              align-v="center"
              align-h="center"
              class="px-5"
              style="height: 150px"
              v-if="type == 'status'"
            >
              <h5 class="pt-4">Please Select a Status</h5>
              <b-form-select v-model="stat" :options="status"></b-form-select>
            </b-row>
          </b-col>
          <b-col cols="4">
            <h5 class="pt-3">Search Selection</h5>
            <table class="table table-white flex md12">
              <thead>
                <tr></tr>
              </thead>
              <tbody class="row">

                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                >
                  <th scope="col">Date Range</th>
                  <td v-if="fromDate && toDate">
                    {{formatDate(fromDate)  }} to {{formatDate(toDate)  }}
                  </td>
                  <td v-else>No Range Provided</td>
                </tr>
                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                >
                  <th scope="col">Year Range</th>
                  <td v-if="fromYear && toYear">
                    {{ fromYear }} to {{ toYear }}
                  </td>
                  <td v-else>No Range Provided</td>
                </tr>
                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                >
                  <th scope="col">user Type</th>
                  <td v-if="user">{{ user }}</td>
                  <td v-else>All User Types</td>
                </tr>
                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                >
                  <th scope="col">Species</th>
                  <td v-if="species">{{ speciesValue }}</td>
                  <td v-else>All Species</td>
                </tr>
                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                >
                  <th scope="col">Crime Types</th>
                  <td v-if="crime">{{ crimeValue }}</td>
                  <td v-else>All Crime Types</td>
                </tr>
                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                >
                  <th scope="col">Level of Reporting</th>
                  <td v-if="level">{{ levelValue }}</td>
                  <td v-else>All Levels</td>
                </tr>
                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                  v-if="level == 'online'"
                >
                  <th scope="col">Source Types</th>
                  <td v-if="source">{{ sourceValue }}</td>
                  <td v-else>All Source Types</td>
                </tr>
                <tr
                  class="col-md-12"
                  style="font-style: italic !important; font-size: 14px"
                >
                  <th scope="col">Status</th>
                  <td v-if="stat">{{ stat }}</td>
                  <td v-else>All Status</td>
                </tr>
              </tbody>
            </table>
            <b-row class="pt-3">
              <b-col cols="2" offset="2">
                <b-button class="px-3" variant="success" @click="search()"
                  >Apply</b-button
                >
              </b-col>
              <b-col cols="2" offset="2">
                <b-button class="px-3" @click="reset()" variant="success"
                  >Reset</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <b-row
        v-if="searchData.length > 0"
        align-h="center"
        style="padding-top: 30px"
      >
        <span>
          Your file is ready. Please click on the button to download.
          <vue-excel-xlsx
            :data="searchData"
            :columns="columns"
            :filename="'Analytics'"
            class="btn btn-outline-success px-1 py-1"
            >Download in Excel
            <template v-slot:cell(knownSpecies)="data">
              <span v-if="data.item.knownSpecies == 'yes'">
                {{ data.item.usertype }}
              </span>
            </template>
          </vue-excel-xlsx>
        </span>
      </b-row>
      <b-row
        v-if="searchData.length == 0 && searchStatus"
        align-h="center"
        style="padding-top: 30px"
      >
        <span>Filtered data is empty. Please select some other filters.</span>
      </b-row>
    </va-card>
  </div>
</template>
<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  data () {
    return {
      visible: false,
      year: null,
      type: 'year',
      buttons: [
        {
          title: 'Year Range',
          value: 'year',
        },
        {
          title: 'Date Range',
          value: 'datewise',
        },
        {
          title: 'User Type',
          value: 'user',
        },
        {
          title: 'Crime Type',
          value: 'crime',
        },
        {
          title: 'Species',
          value: 'species',
        },
        {
          title: 'Level of Reporting',
          value: 'level',
        },
        {
          title: 'Status',
          value: 'status',
        },
      ],

      fromYear: new Date().getFullYear(),
      toYear: new Date().getFullYear(),
      fromDate: null,
      toDate: null,
      users: [
        { name: 'Guest', value: 'guest' },
        { name: 'User', value: 'user' },
      ],
      user: null,
      levels: [],
      level: null,
      crimes: [],
      crime: null,
      status: [],
      stat: null,
      msg: null,
      sources: [],
      source: null,
      allSpecies: [],
      species: null,
      searchData: [],
      searchStatus: false,
      columns: [
        {
          label: 'ID',
          field: 'crimeReportID',
        },
        {
          label: 'User Type',
          field: 'usertype',
        },
        {
          label: 'Level of Reporting',
          field: 'CRtype',
        },
        {
          label: 'URL',
          field: 'url',
        },
        {
          label: 'Source',
          field: 'sourceName',
        },

        {
          label: 'Crime Type',
          field: 'crime',
        },

        {
          label: 'Description',
          field: 'description',
        },
        {
          label: 'Species',
          field: 'speciesName',
        },

        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Reported Date',
          field: 'create_date',
        },
        {
          label: 'Location(Longitude,Latitude)',
          field: 'lonlat',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  computed: {
    levelValue () {
      var temp
      if (this.level == 'online') temp = 'Online Reporting'
      else if (this.level == 'groundlevel') temp = 'Field Reporting'
      return temp
    },
    // userValue() {
    //   var temp;
    //   for (var i = 0; i < this.users.length; i++) {
    //     if (this.users[i]._id == this.user) {
    //       temp = this.users[i].uname;
    //     }
    //   }
    //   return temp;
    // },

    crimeValue () {
      var temp
      for (var i = 0; i < this.crimes.length; i++) {
        if (this.crimes[i]._id == this.crime) {
          temp = this.crimes[i].cname
        }
      }
      return temp
    },
    sourceValue () {
      var temp
      for (var i = 0; i < this.sources.length; i++) {
        if (this.sources[i]._id == this.source) {
          temp = this.sources[i].sname
        }
      }
      return temp
    },
    speciesValue () {
      var temp
      for (var i = 0; i < this.allSpecies.length; i++) {
        if (this.allSpecies[i]._id == this.species) {
          temp = this.allSpecies[i].commonName
        }
      }
      return temp
    },
  },
  watch: {
    fromDate () {
      if (this.fromDate) {
        this.fromYear = this.toYear = null
      }
    },
    fromYear () {
      if (this.fromYear) {
        this.fromDate = this.toDate = null
      }
    },
  },
  beforeMount () {
    this.years()
    // this.userTypes();
    this.statView()
    this.crimeView()
    this.sourceView()
    this.speciesTypes()
  },
  methods: {

    newfunc (val) {
      this.type = val
    },
    years () {
      const year = new Date().getFullYear()

      return Array.from(
        { length: year - 2000 },
        (value, index) => 2001 + index
      )
    },
    crimeView () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/crimetype/list',
      })
        .then((response) => {
          this.crimes = response.data.data
          this.visible = false
        })

        .catch((err) => {
          this.visible = false
          console.log(err)
        })
    },
    statView () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/status/list',
      })
        .then((response) => {
          this.status = response.data.data
          this.visible = false
        })
        .catch((err) => {
          this.visible = false
          console.log(err)
        })
    },
    sourceView () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/source/list',
      })
        .then((response) => {
          this.sources = response.data.data
          this.visible = false
        })
        .catch((err) => {
          this.visible = false
          console.log(err)
        })
    },
    speciesTypes () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/species/list',
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.allSpecies = response.data.data
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
    userTypes () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/usertype/list',
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.users = response.data.data
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
    reset () {
      this.toDate =
        this.fromDate =
         this.toYear =
        this.fromYear =
        this.crime =
        this.level =
        this.user =
        this.species =
        this.source =
        this.stat =
          null
      this.searchData = []
      this.searchStatus = false
      this.$bvToast.toast('Reset Successfully', {
        title: `Reset`,
        solid: true,
        variant: 'success',
      })
    },
    search () {
      this.visible = true
      var data = {}
      if (this.fromYear) data['yearFrom'] = this.fromYear
      if (this.toYear) data['yearTo'] = this.toYear
      if (this.fromDate) data['fromDate'] = this.fromDate
      if (this.toDate) data['toDate'] = this.toDate
      if (this.user) data['userType'] = this.user
      if (this.crime) data['crimeType'] = this.crime
      if (this.species) data['species'] = this.species
      if (this.source) data['source'] = this.source
      if (this.level) data['CR'] = this.level
      if (this.stat) data['status'] = this.stat

      axios({
        method: 'POST',
        url: '/crimereport/analytics/sheet',
        data: data,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.searchStatus = response.data.status
            this.searchData = response.data.data
            for (var i = 0; i < this.searchData.length; i++) {
              this.searchData[i].lonlat =
                this.searchData[i].location[0] +
                ',' +
                this.searchData[i].location[1]
              this.searchData[i].create_date = this.searchData[
                i
              ].create_date.slice(0, 10)
              if (this.searchData[i].knownSpecies == 'yes') {
                if (this.searchData[i].species) {
                  this.searchData[i].speciesName =
                  this.searchData[i].species.commonName
                }
              } else {
                this.searchData[i].speciesName = 'No Data Available'
              }
              if (this.searchData[i].CRtype == 'online') {
                if (this.searchData[i].source) { this.searchData[i].sourceName = this.searchData[i].source.sname }
              } else {
                this.searchData[i].sourceName = 'No Data Available'
              }
              if (this.searchData[i].crimeType) { this.searchData[i].crime = this.searchData[i].crimeType.cname }
            }
            this.visible = false
          } else {
            this.visible = false
            this.msg = response.data.msg
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          // this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>
